import React from 'react';
import { useDispatch } from "react-redux";

import { AppBar, Toolbar, Button, Box } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { logout } from "../../reducers/user";

import { NavLink } from "react-router-dom";
import DocumentUpload from "components/DocumentUploader/DocumentUpload"; 
import './Navbar.scss';
// import Logo from './Logo';

const Navbar = () => {
  const dispatch = useDispatch();
  const handleLogout = () => {
    dispatch(logout());
    localStorage.removeItem("user");
  };

  return (
    <AppBar position="static" className="navbar">
      <Toolbar className="navbar-toolbar">
        <Box className="navbar-logo">
          Czytadło
        </Box>
        <Box className="navbar-buttons">

          <Button className="nav-button" variant="outlined" color="inherit" component={NavLink} to="/">Moja Biblioteka</Button>
          <Button className="nav-button" variant="outlined" color="inherit" component={NavLink} to="/search">Szukaj</Button>
          <DocumentUpload />
          <Button className="nav-button" variant="outlined" color="inherit" onClick={handleLogout} to="/">
            <LogoutIcon />
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
